module.exports = __webpack_public_path__ + "img/watch-fitness.77e91f63.svg";